/* eslint-disable no-param-reassign */
import type { ValidationConfig } from '../../../core/dataProcessor/types';
import { StockData } from '../../../../helper/hxKLine';

// 🆕 为新 ValidationEngine 导出的配置
export const hxKLineAndMultiIndicatorLineValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: 'date', required: true },
    { field: 'y', type: 'number', required: true, array: true }
  ],
  businessRules: [
    {
      name: 'hx-kline-and-multi-indicator-line-stocks-required',
      validator: (data, layer) => {
        const hxKLineLayer = layer as { stocks?: StockData[] };
        return Array.isArray(hxKLineLayer.stocks) && hxKLineLayer.stocks.length > 0;
      },
      message: 'K-line and multi-indicator line chart requires stock configuration',
      suggestion: 'Provide stocks array with at least one valid stock configuration',
      severity: 'error'
    },
    {
      name: 'hx-kline-and-multi-indicator-line-stock-properties',
      validator: (data, layer) => {
        const hxKLineLayer = layer as { stocks?: StockData[] };
        if (!Array.isArray(hxKLineLayer.stocks)) {
          return true;
        }

        return hxKLineLayer.stocks.every((stock: StockData) =>
          Boolean(stock.code && stock.market && stock.name)
        );
      },
      message: 'All stocks must have valid code, market, and name properties',
      suggestion: 'Ensure each stock has code, market, and name properties defined',
      severity: 'error'
    },
    {
      name: 'hx-kline-and-multi-indicator-line-y-array',
      validator: (data, layer) => {
        const { encoding } = layer;
        // 检查y字段是否为数组（多指标）
        return Array.isArray(encoding?.y) && encoding.y.length > 0;
      },
      message: 'Multi-indicator line chart requires y field to be an array of indicator fields',
      suggestion: 'Provide y field as an array containing multiple indicator field names',
      severity: 'error'
    },
    {
      name: 'hx-kline-and-multi-indicator-line-multiple-indicators',
      validator: (data, layer) => {
        const { encoding } = layer;
        if (!Array.isArray(encoding?.y)) {
          return true;
        }

        return encoding.y.length >= 2;
      },
      message: 'Multi-indicator chart should have at least 2 indicators',
      suggestion: 'Provide at least 2 different indicator fields in the y array for comparison',
      severity: 'warning'
    },
    {
      name: 'hx-kline-and-multi-indicator-line-sufficient-data',
      validator: data => Array.isArray(data) && data.length >= 10,
      message: 'Multi-indicator line chart works best with at least 10 data points',
      suggestion: 'Provide at least 10 data points for meaningful indicator analysis',
      severity: 'warning'
    },
    {
      name: 'hx-kline-and-multi-indicator-line-optimal-indicator-count',
      validator: (data, layer) => {
        const { encoding } = layer;
        if (!Array.isArray(encoding?.y)) {
          return true;
        }

        return encoding.y.length <= 8;
      },
      message: 'Multi-indicator chart works best with 8 or fewer indicators',
      suggestion: 'Consider limiting to 8 indicators for better readability and performance',
      severity: 'warning'
    }
  ]
};
